import { Header } from "@/components/layout/Header";
import { Community } from "@/components/sections/Community";
import { Gallery } from "@/components/sections/Gallery";
import { Giveaway } from "@/components/sections/Giveaway";
import { Hero } from "@/components/sections/Hero";
import { Prizes } from "@/components/sections/Prizes";
import { asset } from "@/lib/assets";

export default function App() {
  return (
    <>
      <Header />

      {/* Full viewport on phones (svh tracks the area left by browser chrome);
          on desktop it just needs enough room for the copy and the character,
          so the height comes from the content. */}
      <div
        id="top"
        style={{ backgroundImage: `url('${asset("images/webp/promo-bg.webp")}')` }}
        className="flex min-h-svh flex-col bg-cover bg-center lg:min-h-160"
      >
        <Hero />
      </div>

      <main>
        <Community />
        <Giveaway />
        <Prizes />
        <Gallery />
      </main>
    </>
  );
}
